import React from "react";
import loadable from "@loadable/component";
import usePostHook from "../../customHooks/usePostHook";
import APIS from "../../constant/Endpoint";
import SubjectIcon from "../../Icons/SubjectIcon";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import usePatchHook from "../../customHooks/usePatchHook";
const CreateSubjectComponent = loadable(
  () => import("../../components/Subject/CreateSubject")
);
const CreateSubject = () => {
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["subject"],
  });
  const { mutateAsync: PatchMutateasync, isLoading } = usePatchHook({
    queryKey: ["subject"],
  });
  const handleCreate = async (value: any, reset: any, setError: any) => {
    let formData = {
      ...value,
    };
    const url = `${APIS.SUBJECT}`;
    try {
      const res = await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  const handleIsActive = async (value: any, id: string) => {
    const formData = {
      is_active: value,
    };
    const url = `${APIS.SUBJECT}${id}/`;
    try {
      const res = await PatchMutateasync({ url, formData });
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center`}
      >
        <SubjectIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>Subject</span>
      </div>
      <CreateSubjectComponent
        handleCreate={handleCreate}
        isPostLoading={isPostLoading}
        handleIsActive={handleIsActive}
      />
    </>
  );
};

export default CreateSubject;
